import React from "react"
import { useTranslation } from "react-i18next";
import styles from './multiSelectionBar.module.css'

const MultiSelectionBar = (props) => {//props:{isAllSelected,selectMultipleBtnClicked,OnSelectAllClicked,OnSelectMultipleBtnClicked}
    const [t] = useTranslation('common')

    let BtnSelectAllTitle=t('All')
    if(props.isAllSelected){
        BtnSelectAllTitle=t('Clear')
    }
    let multipleSelectionBtnDiv = [styles.multipleSelectionBtnDiv]
    if (props.selectMultipleBtnClicked) {
        multipleSelectionBtnDiv = [styles.multipleSelectionBtnDiv ,styles.selectMultipleBtnClicked].join(' ')
    }
    return (
        <div className={styles.multipleSelectionDiv}>
            <div className={styles.multipleSelectionBtnDiv} onClick={props.OnSelectAllClicked}>
                <span className={styles.toSelectBtn}>{BtnSelectAllTitle}</span>
            </div>
            <span className={styles.devider}>|</span>
            <div className={multipleSelectionBtnDiv} onClick={props.OnSelectMultipleBtnClicked}>
                <span className={styles.toSelectBtn}>{t('Selection')}</span>
            </div>
        </div >
    )
}

export default MultiSelectionBar;